import { Component } from '@angular/core';
import { ModuleCardComponent } from '../module-card/module-card.component';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { getModuleUrl } from '../../utils/module';
import { TermsComponent } from '../terms/terms.component';
import { openModuleLink } from '../../utils/open-module-link';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [ModuleCardComponent, TermsComponent, CommonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  constructor(
    readonly authService: AuthService,
    readonly apiService: ApiService,
    private router: Router
  ) {}

  isAuthenticated = this.authService.isAuthenticated;
  isAuthenticating = this.authService.isAuthenticating;
  currentUser = this.authService.currentUser;

  getModuleUrl = getModuleUrl;

  scrollToAllModules(): void {
    const allModules = document.querySelector('#all-modules');
    if (allModules) {
      allModules.scrollIntoView({ behavior: 'smooth' });
    }
  }

  async goToFirstModule(): Promise<void> {
    if (!this.currentUser()?.Modules?.length) {
      return;
    } else {
      const firstModule = this.currentUser()?.Modules?.[0];
      const firstModuleUrl = this.getModuleUrl(firstModule!);
      if (!firstModuleUrl) {
        return;
      }
      await openModuleLink({
        code: firstModule!.ModuleCode,
        title: firstModule!.ModuleName,
        router: this.router,
        apiService: this.apiService
      });
    }
  }

  goToAdmin(): void {
    this.router.navigate(['/admin']);
  }
}
